import Matrix from 'util/table/Matrix';

export class AxisError extends Error {
    constructor(message) {
        super(message);
        this.name = "AxisError";
    }
}

/**
 * Class representing an axis
 */
export default class Axis {
    /**
     * @type {Matrix}
     * @readonly
     * */
    matrix;
    /**
     * @type {string}
     * @readonly
     * */
    id;
    /**
     * @type {string}
     * @readonly
     * */
    name;
    /**
     * @type {string}
     * @readonly
     * */
    units;
    /**
     * @type {string}
     * @readonly
     * */
    formattedName;
    /**
     * @type {number}
     * @readonly
     * */
    min;
    /**
     * @type {number}
     * @readonly
     * */
    max;
    /**
     * @type {number}
     * @readonly
     * */
    minLimit;
    /**
     * @type {number}
     * @readonly
     * */
    maxLimit;
    /**
     * @type {boolean}
     * @readonly
     * */
    readOnly;

    /**
     * CreateProjectButton an axis
     * @param {object} obj - object representing a matrix
     * @param {string} [obj.id]
     * @param {string} [obj.name]
     * @param {string} [obj.units]
     * @param {Matrix} obj.matrix
     */
    constructor({id, name, units, min, max, minLimit, maxLimit, readOnly, matrix}) {
        Object.assign(this, {id, name, units, min, max, minLimit, maxLimit, readOnly, matrix}); //assign given obj to new obj

        //todo add limit validation when graham's fixed limit bug

        if (!matrix) throw new AxisError("matrix must be defined");

        this.formattedName = `${this.name} (${this.units})`;

        Object.seal(this); //stop additional fields from being added to new obj
    }
}